export function getStreakWindow({ series, windowDays }) {
  const safe = Array.isArray(series) ? series : [];
  const raw = Number(windowDays);
  const n = Number.isFinite(raw) && raw > 0 ? Math.floor(raw) : 7;
  return { rows: safe.slice(-n), windowDays: n };
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function toFiniteOrNull(value) {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function resolveWindowDays(rawWindowDays, seriesLength) {
  const n = Number(rawWindowDays);
  if (Number.isFinite(n) && n > 0) return Math.floor(n);
  return seriesLength;
}

function buildStreakBase(dailySeries, expectedMetricKey) {
  if (!isPlainObject(dailySeries)) return null;
  if (dailySeries.metric_key !== expectedMetricKey) return null;
  if (!Array.isArray(dailySeries.series)) return null;

  const target = toFiniteOrNull(dailySeries.target_value);
  const window_days = resolveWindowDays(dailySeries.window_days, dailySeries.series.length);

  return { target, window_days, series: dailySeries.series, bad_when: dailySeries.bad_when };
}

export function buildCpaStreakFromDailySeries(dailySeries) {
  const base = buildStreakBase(dailySeries, 'cpa');
  if (!base) return null;

  const series = base.series.map((p) => ({
    date: p?.date,
    cpa: toFiniteOrNull(p?.value),
    spend: p?.spend == null ? null : toFiniteOrNull(p.spend),
    conversions: p?.conversions == null ? null : toFiniteOrNull(p.conversions),
  }));

  const canCount = base.target !== null && base.bad_when === 'above_target';
  const days_over_target = canCount
    ? series.reduce((n, r) => (r.cpa !== null && r.cpa > base.target ? n + 1 : n), 0)
    : null;

  return {
    target_cpa: base.target,
    window_days: base.window_days,
    days_over_target,
    series,
  };
}

export function buildRoasStreakFromDailySeries(dailySeries) {
  const base = buildStreakBase(dailySeries, 'roas');
  if (!base) return null;

  const series = base.series.map((p) => ({
    date: p?.date,
    roas: toFiniteOrNull(p?.value),
    spend: p?.spend == null ? null : toFiniteOrNull(p.spend),
    conversions: p?.conversions == null ? null : toFiniteOrNull(p.conversions),
  }));

  const canCount = base.target !== null && base.bad_when === 'below_target';
  const days_under_target = canCount
    ? series.reduce((n, r) => (r.roas !== null && r.roas < base.target ? n + 1 : n), 0)
    : null;

  return {
    target_roas: base.target,
    window_days: base.window_days,
    days_under_target,
    series,
  };
}
